import { Component } from '@angular/core';
import { ProductService } from 'src/app/api/catalog/product.service';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';

@Component({
  selector: 'app-product-informationdetail-extends',
  templateUrl: './product-informationdetail-extends.component.html',
  styleUrls: ['./product-informationdetail-extends.component.css']
})
export class ProductInformationdetailExtendsComponent {
  item: any = null;
  typeproduct_good: any;
  typeproduct_service: any;
  typeprice_general: any;
  typeprice_unit: any;
  average_summary: any = 0;
  average_total_purchase: any = 0;
  average_purchase: any = 0;
  average_total: any = 0;
  last_price_purchase: any = null;

  constructor(public toolsService: ToolsService, private productService: ProductService) {
    this.typeproduct_good = this.toolsService.searchObjByKey(
      'good',
      constants.PRODUCT.TYPEPRODUCT
    );

    this.typeproduct_service = this.toolsService.searchObjByKey(
      'service',
      constants.PRODUCT.TYPEPRODUCT
    );

    this.typeprice_general = this.toolsService.searchObjByKey(
      'price_general',
      constants.PRODUCT.TYPEPRICE
    );

    this.typeprice_unit = this.toolsService.searchObjByKey(
      'price_unit',
      constants.PRODUCT.TYPEPRICE
    );
  }

  getDataProduct(product: any = null) {
    this.item = product;
    this.productService.getInformationDetail(product.id).subscribe({
      next: (data: any) => {
        this.average_summary = data.average_summary;
        this.average_purchase = data.average_purchase;
        this.average_total_purchase = data.average_total_purchase;
        this.last_price_purchase = data.last_price_purchase;
        this.average_total = data.average_total;
      }
    });
  }
}
